import React from 'react'
import LookupRender from '../../LookupRender'
import { useFormContext, useWatch } from 'react-hook-form'
import { HybridLayoutLookupFieldPropsType } from '../hybridLayout.types'
import { ElementType } from '../../../types/layout.types'
import { useFormBehaviorFieldOverrides } from '../../../form-behavior/useFormBehaviorFieldOverrides'

const LookupViewModeLabelRenderer = ({ element }: { element: ElementType }) => {
  const label = useWatch({ name: `lookupLabels.${element?.keyName}` })
  return (
    <div className="font-primary font-light">
      <label
        htmlFor={element?.keyName}
        className="text-sm font-normal mb-1 block"
      >
        {element?.meta?.label}
      </label>
      <div className="text-xs font-extraLight">{label ?? '--'}</div>
    </div>
  )
}

export const HybridLayoutLookupField: React.FC<HybridLayoutLookupFieldPropsType> =
  React.memo(
    ({
      element,
      fullLayout,
      isAssociated,
      associatedObject,
      formUniqueId,
      mode,
    }) => {
      const {
        setValue,
        control,
        getValues,
        formState: { errors },
      } = useFormContext()

      const baseDisabled = !!element?.isDisabled
      const {
        effectiveDisabled,
        effectiveRequired,
        behaviorLookupAllowedIds,
        hasFormRules,
      } = useFormBehaviorFieldOverrides(
        fullLayout,
        element,
        baseDisabled,
        element?.meta?.required
      )

      return (
        <>
          {mode === 'view' ? (
            <LookupViewModeLabelRenderer element={element} />
          ) : null}
          <div className={`${mode === 'view' ? 'hidden' : ''}`}>
            <LookupRender
              element={
                {
                  ...element,
                  meta: {
                    ...element?.meta,
                    ...fullLayout?.layout_data?.added_fields?.[
                      element?.keyName || ''
                    ],
                  },
                } as ElementType
              }
              errors={errors}
              control={control}
              setValue={setValue}
              getValues={getValues}
              disabled={effectiveDisabled}
              formUniqueId={formUniqueId}
              fullLayout={fullLayout}
              mode="add"
              dataQaId={element?.keyName ?? ''}
              isCustomForm={true}
              isAssociated={isAssociated}
              associatedObject={associatedObject}
              required={effectiveRequired}
              behaviorLookupAllowedIds={
                hasFormRules ? behaviorLookupAllowedIds : undefined
              }
            />
          </div>
        </>
      )
    }
  )
HybridLayoutLookupField.displayName = 'HybridLayoutLookupField'
